import {Typography} from "@material-ui/core";
import ParametriESimTable from "./parametri-esim-table/ParametriESimTable";
import {useEffect, useState} from "react";
import ParametriESimFilter from "./parametri-esim-filter/ParametriESimFilter";
import {updateObject} from "../../../../../shared/utils/updateObject";
import FilterHistory from "../../../../../shared/components/filter-history/FilterHistory";
import {
    SortingAndButtonsAboveTable
} from "../../../../../shared/components/sorting-and-buttons-above-table/SortingAndButtonsAboveTable";
import {parametriESimFilter, sortingCriteria} from "./ParametriESimHelper";
import ESimQrDialog from "../../sim/Dialogs/esim-qr-dialog/ESimQrDialog";
import * as actions from "../../../../../store/e-sim/actions";
import {useDispatch, useSelector} from "react-redux";
import ButtonWithProgress from "../../../../ui/buttons/button-with-progress/ButtonWithProgress";
import GetAppIcon from "@material-ui/icons/GetApp";
import {ESimService} from "../../../../../api/eSimService";
import {toastError, toastWarning} from "../../../../../shared/components/toast/Toast";
import fileSaver from 'file-saver';

const ParametriESim = () => {
    const dispatch = useDispatch()
    const integrationId = useSelector(state => state.authReducer.selectedCompany.integrationId)
    const totalTableData = useSelector(state => state.eSimReducer.parametriESimTableData.total)

    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(5)
    const [filterHistory, setFilterHistory] = useState(parametriESimFilter)
    const [areAllSelected, setAreAllSelected] = useState(false)
    const [sorting, setSorting] = useState(`${sortingCriteria[0].value},desc`)
    const [selectedRows, setSelectedRows] = useState([])
    const [openVerificaDialog, setOpenVerificaDialog] = useState(false)
    const [verificaSim, setVerificaSim] = useState('')
    const [csvDownloadLoading, setCsvDownloadLoading] = useState(false)

    useEffect(() => {
        dispatch(actions.getParametriESimFilterOptions())
    }, [dispatch, integrationId])

    useEffect(() => {
        dispatch(actions.getParametriESimTableData(filterHistory, sorting, page, rowsPerPage))
    }, [dispatch, filterHistory, page, rowsPerPage, sorting, integrationId])

    const handleFilterSearch = (name, value) => {
        setPage(0);
        setFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, {
            [name]: {
                ...currentFilterHistory[name],
                value: value
            }
        }))
    };

    const handleFilterSelectsSearch = (value) => {
        setPage(0);
        setFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, value))
    };

    const handleRemoveBadge = (key, type, index) => {
        setPage(0);
        setAreAllSelected(false)
        if (type !== "date") {
            setFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, {
                [key]: {
                    ...currentFilterHistory[key],
                    value: type === "primitive" ? "" : [...currentFilterHistory[key].value].filter((i, idx) => idx !== index)
                }
            }))
        } else {
            setFilterHistory(currentFilterHistory => updateObject(currentFilterHistory, {
                [key]: {
                    ...currentFilterHistory[key],
                    from: null,
                    to: null
                }
            }))
        }
    };

    const handleResetFilter = () => {
        setPage(0);
        setAreAllSelected(false)
        setFilterHistory(parametriESimFilter);
    };

    const handleSortingChange = (value) => {
        setPage(0)
        setSorting(value)
    };

    const handleAnnullaClick = () => {
        setSelectedRows([])
        setAreAllSelected(false)
    };

    const handleScaricaCsvClick = () => {
        setCsvDownloadLoading(true)
        ESimService.downloadParametriESimCsv(
            integrationId,
            areAllSelected,
            selectedRows.map((r) => r.seriale).join(','),
            filterHistory.numeroDiTelefono.value ? filterHistory.numeroDiTelefono.value : undefined,
            filterHistory.numeroSeriale.value ? filterHistory.numeroSeriale.value : undefined,
            filterHistory.statoSim.value ? filterHistory.statoSim.value : undefined,
            filterHistory.esitoInvio.value ? filterHistory.esitoInvio.value : undefined,
            sorting
        )
            .then((res) => {
                if (res.status === 204) {
                    console.warn("No data was found to be exported in CSV")
                    toastWarning("Non è stato trovato alcun dato da esportare in CSV")
                    return;
                }
                fileSaver.saveAs(res.data, `parametri_esim_${new Date().toISOString()}.csv`)
            })
            .catch((e) => {
                toastError('Errore durante il download del file CSV')
                console.log(e);
            })
            .finally(() => {
                setCsvDownloadLoading(false)
            })
    }

    const scaricaButton = (
        <ButtonWithProgress
            startIcon={<GetAppIcon/>}
            text="scarica .csv"
            handleClick={handleScaricaCsvClick}
            loading={csvDownloadLoading}
            disabled={totalTableData === 0 || !selectedRows.length}
            variant="outlined"
        />
    );

    const handleTablePaginationChange = (page, rowsPerPage) => {
        setPage(page);
        setRowsPerPage(rowsPerPage);
    }

    return (
        <>
            <Typography variant="h6"
                        style={{marginBottom: '1em'}}>Dettagli eSIM</Typography>

            <ParametriESimFilter handleSearchIcon={handleFilterSearch}
                                 handleSelectSearch={handleFilterSelectsSearch}
                                 filter={filterHistory}/>

            <FilterHistory filter={filterHistory}
                           removeFilter={handleRemoveBadge}
                           resetFilter={handleResetFilter}/>

            <SortingAndButtonsAboveTable sortingValue={sorting}
                                         changeSortingCriteria={handleSortingChange}
                                         sortingCriteria={sortingCriteria}
                                         additionalButton={scaricaButton}
                                         hideButton={true}
                                         menuItems={[]}
                                         selectedData={areAllSelected ? selectedRows : selectedRows.length}
                                         handleAnnullaClick={handleAnnullaClick}/>

            <ParametriESimTable selected={selectedRows}
                                setSelected={setSelectedRows}
                                page={page}
                                rowsPerPage={rowsPerPage}
                                handlePaginationChange={handleTablePaginationChange}
                                areAllSelected={areAllSelected}
                                setAreAllSelected={setAreAllSelected}
                                setOpenVerificaDialog={setOpenVerificaDialog}
                                setVerificaSim={setVerificaSim}
                                filter={filterHistory}/>

            {openVerificaDialog ?
                <ESimQrDialog open={openVerificaDialog}
                              handleDialogClose={() => setOpenVerificaDialog(false)}
                              sims={[verificaSim]}
                              displayMaxNumberOfDownloads={true}/> : null}
        </>
    )
}

export default ParametriESim;
